import {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import { Search, FileCopy } from "@material-ui/icons";
import { AppContext } from "./../contexts/appContext";
import { promotionAPI } from "../services/PromotionService";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { Autocomplete } from "@mui/material";
import Modal from "../components/Modal/promotion";
import moment from "moment";
import Download from "downloadjs";

const Promotion = () => {
  const { user } = useContext(AppContext);
  const [search, setSearch] = useState(null);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [promotion, setPromotion] = useState([]);
  const [allCat, setAllCat] = useState([]);
  const [cat, setCat] = useState(null);
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [startDate, setStartDate] = useState(() => {
    let date = moment().subtract(1, "month").utcOffset(0);
    date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    return date.toDate();
  });
  const [endDate, setEndDate] = useState(() => {
    let date = moment().add(1, "month").utcOffset(0);
    date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    return date.toDate();
  });
  const searchRef = useRef({ name: "", count: 0 });

  const getPormotion = useCallback(
    async (newPage) => {
      try {
        if (search == searchRef.current.name) {
          searchRef.current.count = searchRef.current.count + 1;
        } else {
          searchRef.current.name = search;
          searchRef.current.count = 1;
        }
        const { status, message } = await promotionAPI.getPromotion({
          page: newPage || page,
          cat,
          code: search,
          startDate,
          endDate,
        });
        if (status == 200 && message?.message instanceof Array) {
          setTotal(message?.meta?.count || 0);
          if (Array.isArray(message.group_cat)) {
            let gc = message.group_cat.map((res) => res._id).filter((res)=>!!res);
            setAllCat(gc);
          }
          setPromotion(message.message);
        } else throw { message };
      } catch (error) {
        alert(error.message);
      }
    },
    [page, cat, search, startDate, endDate]
  );

  const exportExcel = useCallback(() => {
    if (!loading) {
      setLoading(true);
      promotionAPI
        .getPromotionExcel({
          cat,
          code: search,
          startDate,
          endDate,
        })
        .then((response) => {
          Download(
            response.data,
            `Promotion.xlsx`,
            response.headers["content-type"]
          );
          setLoading(false);
        })
        .catch((error) => {
          alert(error.message);
          setLoading(false);
        });
    }
  }, [loading, page, cat, search, startDate, endDate]);

  const getPromotionDetail = useCallback(async () => {
    try {
      const { status, message } = await promotionAPI.getPromotionById(modal);
      if (status == 200 && message instanceof Object) {
        setModalData(message);
      } else throw { message };
    } catch (error) {
      alert(error.message);
    }
  }, [modal]);

  const maxPage = useMemo(() => {
    return Math.ceil(total / 10);
  }, [total]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (user) {
      getPormotion();
    }
    return () => {
      if (!user) {
        setPromotion([]);
      }
    };
  }, [user, cat, page, startDate, endDate]);

  useEffect(() => {
    if (modal) {
      getPromotionDetail();
    }
    return () => {
      setModalData(null);
    };
  }, [modal]);

  useEffect(() => {
    searchRef.current.name = "";
    searchRef.current.count = 0;
  }, [search]);

  const handleSearch = async () => {
    if (searchRef.current.count < 3) {
      getPormotion(0);
      setPage(0);
    }
  };

  const ChangeNumber = (num) => {
    try {
      let newNum = num.replace(/,/g, "");
      return Number(newNum);
    } catch (error) {
      return 0;
    }
  };

  return (
    <>
      {modalData && (
        <Modal
          open={!!modal}
          setOpen={setModal}
          data={modalData}
          ChangeNumber={ChangeNumber}
        />
      )}
      <Box className="container-promotion">
        <Typography variant="h5" gutterBottom component="div">
          Promotion{" "}
          <FileCopy
            onClick={exportExcel}
            style={{
              cursor: "pointer",
              fontSize: 20,
              color: loading ? "red" : "black",
            }}
          />
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs>
            <Autocomplete
              options={allCat}
              value={cat || null}
              onChange={(event, newValue) => {
                setCat(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Cat..."
                  variant="outlined"
                  style={{ margin: "auto" }}
                  color="primary"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={4} style={{ margin: "auto" }}>
            <TextField
              variant="outlined"
              label="ค้นหา"
              style={{ margin: "auto" }}
              color="primary"
              fullWidth
              value={search || ""}
              onChange={(e) => setSearch(e.target.value)}
              onKeyPress={(e) => {
                if (e.charCode == 13) {
                  handleSearch();
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search
                      style={{ cursor: "pointer" }}
                      onClick={handleSearch}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid style={{ gap:"2px",margin: "auto" }}>
            <Box>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  label="เริ่มต้น"
                  inputFormat="dd/MM/yyyy"
                  value={startDate}
                  onChange={(newDate) => setStartDate(newDate)}
                  maxDate={endDate}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
                <DesktopDatePicker
                  label="สิ้นสุด"
                  inputFormat="dd/MM/yyyy"
                  value={endDate}
                  onChange={(newDate) => setEndDate(newDate)}
                  minDate={startDate}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
              </LocalizationProvider>
            </Box>
          </Grid>
        </Grid>
        <TableContainer component={Paper} style={{ marginTop: "10px" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className="table-header-promotion">
                  ครั้งที่
                </TableCell>
                <TableCell className="table-header-promotion">Cat.</TableCell>
                <TableCell className="table-header-promotion">Brand</TableCell>
                <TableCell className="table-header-promotion">
                  Cat./Product Code
                </TableCell>
                <TableCell className="table-header-promotion">
                  Sub.Cat./Product Name
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ textAlign: "center" }}
                >
                  รายละเอียด Promotion
                </TableCell>
                <TableCell className="table-header-promotion">
                  ราคาปกติ
                </TableCell>
                <TableCell className="table-header-promotion">ส่วนลด</TableCell>
                <TableCell className="table-header-promotion">
                  ราคาโปรโมชั่น
                </TableCell>
                <TableCell className="table-header-promotion">BU</TableCell>
                <TableCell className="table-header-promotion">
                  เริ่มต้น
                </TableCell>
                <TableCell className="table-header-promotion">
                  สิ้นสุด
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ textAlign: "center" }}
                >
                  Highlight
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {promotion.map((res) => (
                <TableRow
                  key={res._id}
                  className="table-row-promotion"
                  style={{
                    backgroundColor:
                      !res["Product Highlight"] ||
                      res["Product Highlight"] == "-"
                        ? "transparent"
                        : "cornsilk",
                  }}
                  onClick={() => setModal(res._id)}
                >
                  <TableCell className="table-cell-promotion">
                    {res["ครั้งที่"]}
                  </TableCell>
                  <TableCell className="table-cell-promotion">
                    {res[" Cat "]}
                  </TableCell>
                  <TableCell className="table-cell-promotion mobile-promotion">
                    {res[" Brand "]}
                  </TableCell>
                  <TableCell className="table-cell-promotion">
                    {res["Cat/Product Code"]}
                  </TableCell>
                  <TableCell className="table-cell-promotion">
                    {res[" SubCat/Product Name "]}
                  </TableCell>
                  <TableCell
                    className="table-cell-promotion mobile-promotion"
                    style={{
                      textAlign:
                        !res["Product Highlight"] ||
                        res["Product Highlight"] == "-"
                          ? "center"
                          : "start",
                    }}
                  >
                    {res[" รายละเอียด Promotion "]}
                  </TableCell>
                  <TableCell className="table-cell-promotion mobile-promotion">
                    {res[" ราคาปกติ "]}
                  </TableCell>
                  <TableCell className="table-cell-promotion mobile-promotion">
                    {Number.isNaN(
                      Number(ChangeNumber(res[" ราคาปกติ "])) -
                        Number(ChangeNumber(res[" ราคาโปรโมชั่น "]))
                    )
                      ? "ส่วนลดไม่ใช่ตัวเลข"
                      : Number(ChangeNumber(res[" ราคาปกติ "])) -
                        Number(ChangeNumber(res[" ราคาโปรโมชั่น "]))}
                  </TableCell>
                  <TableCell className="table-cell-promotion">
                    {res[" ราคาโปรโมชั่น "]}
                  </TableCell>
                  <TableCell className="table-cell-promotion mobile-promotion">
                    {res["BU"]}
                  </TableCell>
                  <TableCell className="table-cell-promotion">
                    {moment(res["เริ่มต้น"]).format("DD/MM/YYYY")}
                  </TableCell>
                  <TableCell className="table-cell-promotion">
                    {moment(res["สิ้นสุด"]).format("DD/MM/YYYY")}
                  </TableCell>
                  <TableCell
                    className="table-header-promotion"
                    style={{
                      textAlign:
                        !res["Product Highlight"] ||
                        res["Product Highlight"] == "-"
                          ? "center"
                          : "start",
                    }}
                  >
                    {!res["Product Highlight"] ||
                    res["Product Highlight"] == "-"
                      ? "-"
                      : "Highlight"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {maxPage > 1 && (
          <TablePagination
            rowsPerPageOptions={[]}
            rowsPerPage={10}
            page={page}
            component="div"
            count={total}
            onChangePage={handleChangePage}
          />
        )}
      </Box>
    </>
  );
};

export default Promotion;
